import { getPageCluster } from '@shared/domain/PageCluster.ts';
import type { FrontendTrackingLabels } from '@shared/tracking/TrackingLabels';

/*                                                                                              */
export function frontendPageViewTracking(historic: boolean, entryRule: string): FrontendTrackingLabels {
    const pageCluster = getPageCluster() || 'UNKNOWN';

    const pageViewTracking: FrontendTrackingLabels = {
        san_ListEventType: 'tilelistview',
        ot_PageCluster: pageCluster,
        'wk.san_EntrySelectionRule': entryRule,
    };

    if (historic) pageViewTracking.san_Interaction = 'browser_navigation';

    return pageViewTracking;
}
